const searchConfig = {
	minCharactersBeforeSearch: 3,
	debounceSearchMs: 300,
}

export default searchConfig
